/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "kea": {
        "nu": ["latn"],
        "year": {
          "0": "es anu li",
          "1": "prósimu anu",
          "future": {
            "other": "di li {0} anu"
          },
          "past": {
            "other": "a ten {0} anu"
          },
          "-1": "anu pasadu"
        },
        "year-short": {
          "0": "es anu li",
          "1": "prósimu anu",
          "future": {
            "other": "di li {0} anu"
          },
          "past": {
            "other": "a ten {0} anu"
          },
          "-1": "anu pasadu"
        },
        "year-narrow": {
          "0": "es anu li",
          "1": "prósimu anu",
          "future": {
            "other": "di li {0} anu"
          },
          "past": {
            "other": "a ten {0} anu"
          },
          "-1": "anu pasadu"
        },
        "quarter": {
          "0": "es trimestri li",
          "1": "prósimu trimestri",
          "future": {
            "other": "di li {0} trimestri"
          },
          "past": {
            "other": "a ten {0} trimestri"
          },
          "-1": "trimestri pasadu"
        },
        "quarter-short": {
          "0": "es trimestri li",
          "1": "prósimu trimestri",
          "future": {
            "other": "di li {0} trim."
          },
          "past": {
            "other": "a ten {0} trim."
          },
          "-1": "trimestri pasadu"
        },
        "quarter-narrow": {
          "0": "es trimestri li",
          "1": "prósimu trimestri",
          "future": {
            "other": "di li {0} trim."
          },
          "past": {
            "other": "a ten {0} trim."
          },
          "-1": "trimestri pasadu"
        },
        "month": {
          "0": "es mes li",
          "1": "prósimu mes",
          "future": {
            "other": "di li {0} mes"
          },
          "past": {
            "other": "a ten {0} mes"
          },
          "-1": "mes pasadu"
        },
        "month-short": {
          "0": "es mes li",
          "1": "prósimu mes",
          "future": {
            "other": "di li {0} mes"
          },
          "past": {
            "other": "a ten {0} mes"
          },
          "-1": "mes pasadu"
        },
        "month-narrow": {
          "0": "es mes li",
          "1": "prósimu mes",
          "future": {
            "other": "di li {0} mes"
          },
          "past": {
            "other": "a ten {0} mes"
          },
          "-1": "mes pasadu"
        },
        "week": {
          "0": "es simana li",
          "1": "prósimu simana",
          "future": {
            "other": "di li {0} simana"
          },
          "past": {
            "other": "a ten {0} simana"
          },
          "-1": "simana pasadu"
        },
        "week-short": {
          "0": "es simana li",
          "1": "prósimu simana",
          "future": {
            "other": "di li {0} sim."
          },
          "past": {
            "other": "a ten {0} sim."
          },
          "-1": "simana pasadu"
        },
        "week-narrow": {
          "0": "es simana li",
          "1": "prósimu simana",
          "future": {
            "other": "di li {0} sim."
          },
          "past": {
            "other": "a ten {0} sim."
          },
          "-1": "simana pasadu"
        },
        "day": {
          "0": "oji",
          "1": "manhan",
          "future": {
            "other": "di li {0} dia"
          },
          "past": {
            "other": "a ten {0} dia"
          },
          "-1": "onti"
        },
        "day-short": {
          "0": "oji",
          "1": "manhan",
          "future": {
            "other": "di li {0} dia"
          },
          "past": {
            "other": "a ten {0} dia"
          },
          "-1": "onti"
        },
        "day-narrow": {
          "0": "oji",
          "1": "manhan",
          "future": {
            "other": "di li {0} dia"
          },
          "past": {
            "other": "a ten {0} dia"
          },
          "-1": "onti"
        },
        "hour": {
          "0": "es ora li",
          "future": {
            "other": "di li {0} ora"
          },
          "past": {
            "other": "a ten {0} ora"
          }
        },
        "hour-short": {
          "0": "es ora li",
          "future": {
            "other": "di li {0} ora"
          },
          "past": {
            "other": "a ten {0} ora"
          }
        },
        "hour-narrow": {
          "0": "es ora li",
          "future": {
            "other": "di li {0} ora"
          },
          "past": {
            "other": "a ten {0} ora"
          }
        },
        "minute": {
          "0": "es minutu li",
          "future": {
            "other": "di li {0} minutu"
          },
          "past": {
            "other": "a ten {0} minutu"
          }
        },
        "minute-short": {
          "0": "es minutu li",
          "future": {
            "other": "di li {0} min"
          },
          "past": {
            "other": "a ten {0} min"
          }
        },
        "minute-narrow": {
          "0": "es minutu li",
          "future": {
            "other": "di li {0} m"
          },
          "past": {
            "other": "a ten {0} m"
          }
        },
        "second": {
          "0": "agora",
          "future": {
            "other": "di li {0} sigundu"
          },
          "past": {
            "other": "a ten {0} sigundu"
          }
        },
        "second-short": {
          "0": "agora",
          "future": {
            "other": "di li {0} sig"
          },
          "past": {
            "other": "a ten {0} sig"
          }
        },
        "second-narrow": {
          "0": "agora",
          "future": {
            "other": "di li {0} s"
          },
          "past": {
            "other": "a ten {0} s"
          }
        }
      }
    },
    "availableLocales": ["kea"],
    "aliases": {},
    "parentLocales": {}
  });
}